export const inputStyling =
  'font-medium text-blue-900 text-sm h-10 border-blue-900';

export const activeYearButtonSting = `inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold text-white`;

export const labelInputStyling =
  'pb-1 w-[100%] border-blue-900 text-sm font-medium text-blue-900';
